module.exports = __webpack_public_path__ + "static/media/jsontotable.b7d35d75.svg";